import {useContext} from 'react';

import {MenuItemsStateContext} from './MenuItemsStateContext';

export function useMenuItemsState() {
  const context = useContext(MenuItemsStateContext);

  if (context === undefined) {
    throw new Error('useMenuItemsState must be used within a MenuItemsStateProvider');
  }

  return context;
}
